import { Link } from "wouter";
import type { SentRow } from "@/hooks/useCoiDetail";

/** Work we sent their way: the reciprocity side of the relationship. */
export function CoiSentTable({ rows, name }: { rows: SentRow[]; name: string }) {
  if (rows.length === 0) {
    return <p className="text-sm text-muted-foreground italic">Nothing logged as sent to {name} yet. Buy-side, financing and estate work you refer their way goes here.</p>;
  }
  return (
    <ul className="divide-y text-sm">
      {rows.map((r) => (
        <li key={r.id} className="flex items-center justify-between py-2">
          <div>
            <span className="font-medium">{r.title.replace(/^Referral sent: /, "")}</span>
            {r.companyId && <> · <Link href={`/prospects/${r.companyId}`} className="hover:underline text-muted-foreground">{r.companyName}</Link></>}
            {r.content && <div className="text-xs text-muted-foreground">{r.content}</div>}
          </div>
          <span className="text-xs text-muted-foreground">{new Date(r.at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}{r.byName ? ` · ${r.byName}` : ""}</span>
        </li>
      ))}
    </ul>
  );
}
